import React from 'react'
import Feeds from './Feeds'
import WebService from 'api/explus-api'

class FeedsContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      highlights: []
    }
  }

  componentDidMount() {
    WebService.ajaxGet('web/highlights').then(data => {
      if (data.nodes) {
        this.setState({highlights: data.nodes})
      }
    })
  }

  render() {
    return <Feeds highlights={this.state.highlights} childId={ this.props.childId }/>
  }
}

export default FeedsContainer
